import { Component, NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageNotFoundComponent } from 'src/app/layout/pages/page-not-found/page-not-found.component';
import { AddUserComponent } from './add-user/add-user.component';
import { AllUsersComponent } from './all-users/all-users.component';
import { EditUserSmartComponent } from './edit-user/edit-user-smart.component';

import { ManageUsersComponent } from './manage-users.component';

export const userManagement: Routes = [
  {
    path: 'all-users', component: AllUsersComponent,
  },
  {
    path: 'add-user', component: AddUserComponent,
  },
  {
    path: 'edit-user/:id', component: EditUserSmartComponent,
  },
  {
    path: '', redirectTo: 'all-users', pathMatch: 'full'
  },
  {
    path: '**', component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(userManagement)],
  exports: [RouterModule]
})
export class ManageUsersRoutingModule { }
